// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".information-list-mobile__information{font-size:13px;line-height:20px;margin-top:12px;display:flex}.information-list-mobile__information:first-child{margin-top:0}.information-list-mobile__icon{fill:#aeb4c2;margin-right:8px}.information-list-mobile__icon._is-purchased{fill:#fe6564}", ""]);
// Exports
module.exports = exports;
